import { MutationTree } from "vuex";
import types from "@/store/types";

import { RootState } from "@/store/state";

export const mutations: MutationTree<RootState> = {
    [types.mutations.SET_LAST_CONNECTED_TIME]: (state: RootState, lastConnectedTime: number | undefined) => {
        state.lastConnectedTime = lastConnectedTime;
    },
    [types.mutations.SET_IS_ONLINE]: (state: RootState, isOnline: boolean) => {
        state.isOnline = isOnline;
    },
};
